<template>
<v-app>
  <v-container>
  <div>
    <h4 v-if="cust.Role !== 'Admin' || !authenticated">
      You are not Authorised <a @click="auth.login()">Log In</a> to continue.
    </h4>
    <p>Collections</p>
    <div v-if="cust.Role === 'Admin' && authenticated">
      <div id="mainBody">
      <div id="header">
        <span><label for="addCollectionInput"> Add Collection </label>
          <b-input type="text" v-model="addCollectionInput" name="addCollectionInput"></b-input>
          <button v-if="addCollectionInput" class="btn btn-primary btn-margin" @click="addCollValidate(addCollectionInput)">Add New Collection</button>
          <p v-if="fieldError && addCollectionInput">This Collection already Exists!</p>
        </span>
        <br>
        <br>
        <label for="collectionFilter">Filter Collections</label>
        <b-select name="collectionFilter" v-model="selected" >
          <option value="All">All</option>
          <option value="Alive">Alive</option>
          <option value="Dead">Dead</option>
        </b-select>
        <br>
        <form>
          <span v-if="collection.Name">
            <br>
            <label>Edit Collection</label>
            <b-input name="Name" type="text" :value="collection.Name" @change="onCollectionChangeName"></b-input>
            <p v-if="editFieldError">This Collection already Exists!</p>
                    <b-select name="editCollectionFilter" :value="collection.Region" @change="onCollectionChangeRegion" >
                      <option value="UK">UK</option>
                      <option value="EU">EU</option>
                      <option value="EXPORT">EXPORT</option>
                    </b-select>
                    <label for="Dead">Dead?</label>
            <input name="Dead" type="checkbox" :checked="collection.Dead" @change="onCollectionChangeDead" >
            <br>
            <span v-if="collection.Name">
              <button v-if="!editFieldError" class="btn btn-primary btn-margin" @click="saveCollection">Save</button>
              <button class="btn btn-primary btn-margin" @click="clearCollection">Abandon</button>
            </span>
          </span>
        </form>
      </div>
      <div id="collectionList">
        <table class="tblStriped">
          <th width="300px">Collection</th><th>Region</th><th>Dead</th><th></th><th></th>
          <tr :id="collection._id" v-for="collection in sortedCollections" :key="collection._id" >
            <td><p class="collection" disabled="true" name="Name" type="text" :value="collection.Name" >{{collection.Name}}</p></td>
            <td><p class="collection" disabled="true" name="Name" type="text" :value="collection.Region" >{{collection.Region}}</p></td>
            <td class="tickboxes"><input name="Dead" type="checkbox" disabled="true" :checked="collection.Dead" ></td>
            <td><button @click="editCollection(collection._id)">Edit</button></td>
            <td><button @click="deleteCollectionFn(collection._id)">Delete</button></td>
          </tr>
        </table>
      </div>
      </div>
    </div>
  </div>
  </v-container>
</v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import collection from './Collection'
export default {
  name: 'collections',
  computed: {
    ...mapGetters([
      'collections',
      'collection'
    ]),
    sortedCollections () {
      const filtered = this.collections.slice(0).sort((a, b) => {
        let x = a.Name.toLowerCase()
        let y = b.Name.toLowerCase()
        if (x < y) { return -1 }
        if (x > y) { return 1 }
      })
      if (this.selected === 'All') { return filtered }
      const filterType =
        this.selected === 'Dead'
      const filtered2 = filtered.filter(coll => coll.Dead === filterType)
      return filtered2
    }
  },
  created () {
    this.$store.dispatch('getCollections')
  },
  data () {
    return {
      selected: 'All',
      addCollectionInput: '',
      fieldError: false,
      editFieldError: false
    }
  },
  changed: {
  },
  methods: {
    ...mapActions([
      'getCollections',
      'addCollection',
      'updateCollection',
      'getCollection',
      'deleteCollection'
    ]),
    deleteCollectionFn (coll) {
      this.deleteCollection(coll)
        .then((response) => {
          this.$store.dispatch('getCollections')
        })
    },
    editCollection (coll) {
      this.getCollection(coll)
    },
    saveCollection (evt) {
      evt.preventDefault()
      this.$store.dispatch('updateCollection', this.collection)
        .then((response) => {
          this.$store.dispatch('getCollections')
          this.$store.commit('CLEAR_COLLECTION')
        })
    },
    onCollectionChangeName (evt) {
      this.editFieldError = false
      const element = evt
      let capName = element.toUpperCase()
      let colls = this.collections.find(coll => coll.Name.toUpperCase() === capName)
      if (!colls) {
        this.$store.commit(`UPDATE_COLLECTION_NAME`, element)
      } else {
        this.editFieldError = true
      }
    },
    onCollectionChangeDead (evt) {
      const element = evt.target
      this.$store.commit(`UPDATE_COLLECTION_DEAD`, element.checked)
    },
    onCollectionChangeRegion (evt) {
      const element = evt
      this.$store.commit(`UPDATE_COLLECTION_REGION`, element)
    },
    clearCollection (evt) {
      evt.preventDefault()
      this.$store.commit('CLEAR_COLLECTION')
      this.editFieldError = false
    },
    addCollValidate (Name) {
      let capName = Name.toUpperCase()
      this.fieldError = false
      let colls = this.collections.find(coll => coll.Name.toUpperCase() === capName)
      if (!colls) {
        this.$store.dispatch('addCollection', capName)
          .then((response) => {
            this.$store.dispatch('getCollections')
            this.addCollectionInput = []
          })
      } else {
        this.fieldError = true
      }
    }
  },
  components: {
  },
  props: ['auth', 'authenticated', 'cust']
}
</script>

<style>
.collection {
  width: 100%
}
#collectionList {
  position: relative;
  top: 150px;
}
#header {
  position: relative;
  background-color: white;
  z-index: 1000;
  width: 100%
}
#mainBody {
  position: relative;
  overflow:visible
}
body {
  height: 100%
}
</style>
